import React from 'react';
import { Modal, Box, Grid, Tooltip } from '@mui/material';
import { Rnd } from 'react-rnd';
import { closeIconBlack } from '../../shared/assets/images';
import DashboardBarchart from './dashboard_barchart';
// import  DashboardOverviewBarchart  from './dashboard_overview_barchart';
// import { data } from './argo';

function Dashboard(props) {
  const { visibleCompareV, handleCloseCompareV, data, conc_calc, argoProducts, translateObject, sliderRecoveryValue } = props;

  return (
    // <Draggable handle='.argoComp-box'
    // cancel='.argoComp-header-text, .content-tab-title, .MuiButton-contained'>
    <Modal
      hideBackdrop
      open={visibleCompareV}
      onClose={handleCloseCompareV}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
      className="argoComp-modal"
    >
      <Box className=''>
        <Rnd
          default={{
            width: '85%',
            x: ((window.innerWidth / 2) - ((85 * (window.innerWidth / 100)) / 2)),
            y: ((window.innerHeight / 2) - ((50 * (window.innerHeight / 100)) / 2)),
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          allowAnyClick={false}
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          minWidth='47%'
          cancel=".ro-table-grid"
          onDragStart={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          className='argoComp-box'>
          <Grid container className='argoComp-grid-container'>
            <Grid item xs={12}>
              <Grid item xs={12} className='model_header'>
                <div className='model_header_text S_heading'>{translateObject('Antiscalant Dashboard')}</div>
                <div className='argoComp-close-icon'>
                  <Tooltip title="Close">
                    <img
                      src={closeIconBlack}
                      alt="close"
                      onClick={handleCloseCompareV}
                      style={{ width: '14px', padding: '11px' }}
                      className="pointer"
                    />
                  </Tooltip>
                </div>
              </Grid>
              <Grid item xs={12} className='argoComp-content-grid'>
                <DashboardBarchart data={data} conc_calc={conc_calc} argoProducts={argoProducts}  sliderRecoveryValue={sliderRecoveryValue}/>
              </Grid>
            </Grid>
          </Grid>
        </Rnd>
      </Box>
    </Modal>
  );
}

export default Dashboard;